var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 60,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Send Email")]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [_vm._t("text-content")],
        2
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c("div", { staticStyle: { "align-self": "flex-start" } }, [
              false
                ? _c(
                    "button",
                    {
                      staticClass: "button tooltip is-tooltip-topleft",
                      attrs: { "data-tooltip": "Attach media" },
                      on: {
                        click: function ($event) {
                          return _vm.attach()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-paperclip mdi-18px" }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticStyle: { "align-self": "flex-end" } }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.toggleAttachButton,
                      expression: "!toggleAttachButton",
                    },
                  ],
                  staticClass: "button is-primary tooltip is-tooltip-topright",
                  attrs: {
                    "data-tooltip": "Send Email",
                    disabled: !_vm.enableSend,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.send()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-send mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Send")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "dropdown",
                  class: { "is-active": _vm.showAttachDropdown },
                  staticStyle: { display: "inline-block" },
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.enableAttach,
                          expression: "enableAttach",
                        },
                      ],
                      staticClass: "button is-primary tooltip",
                      attrs: {
                        "data-tooltip": [
                          !_vm.toggleAttachButton ? "Attach" : "Done",
                        ],
                        disabled: !_vm.enableAttach,
                      },
                      on: { click: _vm.toggleAttachDropdown },
                    },
                    [
                      !_vm.toggleAttachButton
                        ? _c("span", { staticClass: "icon is-small" }, [
                            _c("i", {
                              staticClass: "mdi mdi-18px mdi-paperclip",
                            }),
                          ])
                        : _c("span", [_vm._v("Done")]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      staticStyle: {
                        left: "-120px",
                        right: "auto",
                        top: "auto",
                        bottom: "100%",
                        transform: "translateY(-8px)",
                      },
                      attrs: { role: "menu" },
                    },
                    [
                      _c("div", {
                        staticStyle: {
                          position: "absolute",
                          left: "130px",
                          bottom: "-8px",
                          width: "0",
                          height: "0",
                          "border-left": "8px solid transparent",
                          "border-right": "8px solid transparent",
                          "border-top": "8px solid #fff",
                          "z-index": "2",
                        },
                      }),
                      _c("div", { staticClass: "dropdown-content" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.attachImages },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass: "mdi mdi-image-multiple",
                              }),
                            ]),
                            _vm._v(" Images "),
                          ]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.attachDocs },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass: "mdi mdi-file-document-outline",
                              }),
                            ]),
                            _vm._v(" Documents "),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.toggleAttachButton,
                      expression: "!toggleAttachButton",
                    },
                  ],
                  staticClass: "button tooltip is-tooltip-topright",
                  attrs: { "data-tooltip": "Discard Email" },
                  on: {
                    click: function ($event) {
                      return _vm.discard()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-delete mdi-18px" }),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }